/* eslint-disable react/jsx-first-prop-new-line */
/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import { Controller } from 'react-hook-form';
import Select from 'react-select';
import { FormattedMessage, useIntl } from 'react-intl';
import { customStyles } from 'src/common/inputStyles';

import { acceptingBookingOptions, disabledReservationSourcesOptions, managingTablesOptions } from './settingsOptions';

const OnlineBookingsSettings = (props) => {
	const { register, control } = props;
	const intl = useIntl();

	return (
		<>
			<div className="row pb-5">
				<div className="col-12">
					<div className="mb-0 fs-2 fw-bold">
						<FormattedMessage id="LOCATION.SETTINGS.NEW_BOOKINGS" />
					</div>
				</div>
			</div>

			<div className="row pb-5">
				<Controller
					name="online_booking_settings.assign_tables"
					control={control}
					render={({ field }) => (
						<div className="col-12 col-sm-6">
							<div className="pb-3 fs-7 fw-bold">
								<FormattedMessage id="LOCATION.SETTINGS.MANAGING_TABLES" />
							</div>
							<div className="select-container">
								<select
									className="fs-6 fw-bold disabled"
									aria-label="Select example"
									{...register('online_booking_settings.assign_tables')}
									disabled
								>
									{managingTablesOptions.map((tableOption) => (
										<option key={tableOption.value} value={tableOption.value} defaultValue={tableOption.value}>
											<FormattedMessage id={tableOption.label} />
										</option>
									))}
								</select>
								<i className="fa-solid fa-chevron-down arrow-icon"></i>
							</div>
							<p className="mb-0 pt-2 secondary-text fs-7">
								<FormattedMessage id="LOCATION.SETTINGS.MANAGING_TABLES_TXT" />
							</p>
						</div>
					)}
				/>
				<Controller
					name="online_booking_settings.accept_bookings"
					control={control}
					render={({ field }) => (
						<div className="col-12 col-sm-6">
							<div className="pb-3 pt-5 pt-sm-0 fs-7 fw-bold">
								<FormattedMessage id="LOCATION.SETTINGS.ACCEPT_BOOKINGS" />
							</div>
							<div className="select-container">
								<select className="fs-6 fw-bold" aria-label="Select example" {...register('online_booking_settings.accept_bookings')}>
									{acceptingBookingOptions.map((acceptingOption) => (
										<option key={acceptingOption.value} value={acceptingOption.value} defaultValue={acceptingOption.value}>
											<FormattedMessage id={acceptingOption.label} />
										</option>
									))}
								</select>
								<i className="fa-solid fa-chevron-down arrow-icon"></i>
							</div>
							<p className="mb-0 pt-2 secondary-text fs-7">
								<FormattedMessage id="LOCATION.SETTINGS.ACCEPT_BOOKINGS_TXT" />
							</p>
						</div>
					)}
				/>
			</div>
			<div className="row">
				<div className="col-12">
					<div className="pb-3 fs-7 fw-bold">
						<FormattedMessage id="LOCATION.SETTINGS.DISABLE_RESERVATION_CHANNELS" />
					</div>
					<Controller
						name="online_booking_settings.disabled_sources"
						control={control}
						render={({ field: { value, name, onChange, ref } }) => (
							<Select
								closeMenuOnSelect={false}
								components={{}}
								inputRef={ref}
								isMulti
								name={name}
								onChange={onChange}
								options={disabledReservationSourcesOptions}
								placeholder={intl.formatMessage({ id: 'PLACEHOLDER.SELECT' })}
								styles={customStyles}
								value={value}
							/>
						)}
					/>
					<p className="mb-0 secondary-text fs-7 pt-2">
						<FormattedMessage id="LOCATION.SETTINGS.DISABLE_RESERVATION_CHANNELS_DESC" />
					</p>
				</div>
			</div>

			<div className="row">
				<div className="col-12">
					<div className="separator my-5" />
				</div>
			</div>
		</>
	);
};

export default OnlineBookingsSettings;
